export const setToken = token => {
  return localStorage.setItem('JWT', token);
};
export const removeToken = token => {
  return localStorage.removeItem('JWT');
};
export const setRefreshToken = token => {
  return localStorage.setItem('refresh_token', token);
};
export const getRefreshToken = () => {
  return localStorage.getItem('refresh_token');
};
export const removeRefreshToken = token => {
  return localStorage.removeItem('refresh_token');
};

export const getToken = () => {
  return localStorage.getItem('JWT');
};

export const setItem = (name, item) => {
  return localStorage.setItem(name, item);
};

export const getItem = name => {
  return localStorage.getItem(name);
};
export const removeItem = name => {
  return localStorage.removeItem(name);
};
